import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import { useNavigate } from 'react-router-dom'
import { useMediaQuery } from '@mui/material'
import { useState } from 'react'


export default function VibioGetStartedForm() {
    const [vibioUsername, setVibioUsername] = useState('')
    const [label, setLabel] = useState('vibio.co/you')

    const navigate = useNavigate()
    const isMobile = useMediaQuery('(max-width:950px)')


    const handleVibioUsernameChange = (event) => {
        setVibioUsername(event.target.value)
    }

    const handleSubmit = (event) => {
        event.preventDefault()
        // You can add your form submission logic here
        console.log('Submitted username:', vibioUsername)
        // Clear the email field after submission
        setVibioUsername('')
        navigate("/signup")
    }

    const handleTextFieldClick = () => {
        setLabel('vibio.co/')
    }

    return (

        <Box
            component="form"
            noValidate
            onSubmit={handleSubmit}
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: isMobile ? 'center' : 'start',
                fontFamily: 'catamaran',
            }}>
            <section style={{
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                flexWrap: 'wrap',
                gap: isMobile ? '1rem' : 0,
                width: isMobile ? '80%' : 'available',
                padding: '.8rem 1.6rem',
                background: '#f2f2f2',
                borderRadius: '32px',
            }}>
                <TextField
                    label={label}
                    variant="outlined"
                    size="medium"
                    type="text"
                    placeholder='your name'
                    value={vibioUsername}
                    onChange={handleVibioUsernameChange}
                    onClick={handleTextFieldClick}
                    sx={{
                        mr: 1.2,
                        border: 'none',
                        backgroundColor: '#fcfcfc',
                        gap: 4,
                        fontFamily: 'catamaran',
                        borderRadius: '10px',
                    }}
                />

                <Button
                    type="submit"
                    variant="contained"
                    disableElevation
                    sx={{
                        p: '.8rem 1rem',
                        fontFamily: 'inherit',
                        backgroundColor: 'primary.main',
                        color: '#fff',
                        textTransform: 'none',
                        boxShadow: "4px 5px 0px #000",
                        borderRadius: '50px',
                        width: isMobile ? '100%' : 'auto',
                    }}
                >
                    <span style={{ fontSize: '1rem', fontWeight: 900 }}>
                        Create My Vibio
                    </span>
                </Button>
            </section>
            <section style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'inherit',
            }}>
                <p style={{
                    fontWeight: 500,
                    color: "#495057",
                    textAlign: 'center',
                }}>
                    ✔ 60-second easy setup
                </p>
                <p style={{
                    fontWeight: 700,
                    color: "#495057",
                    textAlign: 'center',
                    margin: 0,
                }}>
                    1.1K+ creators and businesses use Vibio
                </p>
            </section>
        </Box>
    )
}
